import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommentIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 33.5,
	height: 31.056,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_8417",
		"data-name": "Group 8417",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9369",
				"data-name": "Path 9369",
				d: "M32.6,13.6c0,7.233-7.185,13.1-16.052,13.1a19.254,19.254,0,0,1-5.624-.822L1.7,30.16,5.32,22.948A12.02,12.02,0,0,1,.5,13.6C.5,6.364,7.685.5,16.552.5S32.6,6.364,32.6,13.6Z",
				transform: "translate(0.199 0.199)",
				fill: "#fff"
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_582",
				"data-name": "Line 582",
				x2: 9.072,
				transform: "translate(10.468 10.642)",
				fill: "none",
				stroke: "#70a6fc",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_583",
				"data-name": "Line 583",
				x2: 13.261,
				transform: "translate(10.468 14.829)",
				fill: "none",
				stroke: "#70a6fc",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("line", {
				id: "Line_584",
				"data-name": "Line 584",
				x2: 13.261,
				transform: "translate(10.468 19.016)",
				fill: "none",
				stroke: "#70a6fc",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})
		]
	})
});
export default SvgCommentIcon;
